export default defineNuxtRouteMiddleware(async (to, from) => {
	if (import.meta.server || !from.name) return;

	const {findRedirect, fetchRedirect, getRedirects, fetchRedirects} = useRedirects();
	let redirects = getRedirects();
	if (!redirects) redirects = await fetchRedirects();

	// Find matching redirect and redirect if found
	const hasRedirect = findRedirect(redirects, to.fullPath);
	if (hasRedirect) {
		const redirect = await fetchRedirect(to.fullPath);
		if (redirect) {
			const redirectUrl = redirect.redirect_url_without_domain;
			const isExternal = redirectUrl.startsWith('http://') || redirectUrl.startsWith('https://') || redirectUrl.startsWith('//') || /\.[a-zA-Z0-9]+$/.test(redirectUrl.split('?')[0]);
			return navigateTo(redirectUrl, {
				redirectCode: redirect.redirect_code ? redirect.redirect_code : 301,
				external: isExternal,
			});
		}
	}
});
